import { render, staticRenderFns } from "./BaseStepperHeader.vue?vue&type=template&id=5644c714&scoped=true&%23header=true"
import script from "./BaseStepperHeader.vue?vue&type=script&lang=js"
export * from "./BaseStepperHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseStepperHeader.vue?vue&type=style&index=0&id=5644c714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644c714",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
